<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'checkpointfields' }">Checkpoint Fields</el-breadcrumb-item>
            <el-breadcrumb-item v-if="$route.params.fieldId">Edit</el-breadcrumb-item>
            <el-breadcrumb-item v-else>Create</el-breadcrumb-item>
        </el-breadcrumb>

        <card class="mt-3">
            <template slot="header">
                <span v-if="$route.params.fieldId">Edit Field</span>
                <span v-else>New Field</span>
            </template>

            <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
            <div v-else>
                <el-form :model="field" :rules="rules" label-width="300px" :label-position="$store.state.props.isMobile ? 'top' : 'right'">
                    <el-form-item label="Title*">
                        <el-input v-model="field.title"/>
                    </el-form-item>
                    <el-form-item label="Name*" prop="name">
                        <el-input
                            v-model="field.name"
                            placeholder=""/>
                    </el-form-item>
                    <el-form-item label="Type*">
                        <el-select v-model="field.type">
                            <el-option
                                v-for="(type, index) in types"
                                :key="`type-${index}`"
                                :value="type.value"
                                :label="type.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="Required for external checkin">
                        <el-radio-group v-model="field.requiredForExternal">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="Public View">
                        <el-radio-group v-model="field.publicView">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="Public Editable">
                        <el-radio-group v-model="field.publicEditable">
                            <el-radio-button :label="false">No</el-radio-button>
                            <el-radio-button :label="true">Yes</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="Description">
                        <el-input
                            v-model="field.description"
                            type="textarea"
                            rows="5"/>
                    </el-form-item>

                    <el-form-item
                        v-if="['checkboxes', 'list', 'radio'].includes(field.type)"
                        label="Labels">
                            <el-input
                                v-model="field.labels"
                                type="textarea"
                                rows="5"/>
                    </el-form-item>

                    <el-form-item
                        v-if="['checkboxes', 'list', 'radio'].includes(field.type)"
                        label="Values">
                            <el-input
                                v-model="field.values"
                                type="textarea"
                                rows="5"/>
                    </el-form-item> 
                    
                    <!-- <el-form-item
                        v-if="['color', 'integer', 'radio', 'text', 'textarea', 'calendar'].includes(field.type) || (field.type === 'list' && field.multiple === false)"
                        label="Default Value">
                            <el-input
                                v-if="field.type === 'textarea'"
                                v-model="field.defaultValue"
                                type="textarea"
                                rows="5"/>
                            <el-input
                                v-else-if="field.type === 'integer'"
                                v-model="field.defaultValue"
                                type="number"/>
                            <el-date-picker
                                v-else-if="field.type === 'calendar'"
                                v-model="field.defaultValue"
                                placeholder="Choose Date"></el-date-picker>
                            <el-input
                                v-else
                                v-model="field.defaultValue"/>
                    </el-form-item> 
                    
                    <el-form-item
                        v-if="field.type === 'checkboxes' || (field.type === 'list' && field.multiple === true)"
                        label="Default Values">
                            <el-input
                                v-model="field.defaultValue"
                                type="textarea"
                                rows="5"/>
                    </el-form-item> 

                    <el-form-item label="Field Mapping">
                        <el-select v-model="field.fieldMapping">
                            <el-option
                                v-for="type in mappingTypes"
                                :key="`fields-mapping-type-${type.value}`"
                                :label="type.label"
                                :value="type.value"/>
                            <el-option
                                label="None"
                                :value="null"/>
                        </el-select>
                    </el-form-item> -->
                </el-form>
            </div>
            <template slot="footer">
                <div class="d-flex justify-content-end">
                    <el-button
                        type="primary"
                        class="btn btn-primary"
                        :loading="saving"
                        @click="submit()">
                            Save
                    </el-button>
                </div>
            </template>
        </card>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import http from '../../http'

export default {
    mounted () {
        this.getData()
    },
    computed: {
        ...mapState([
            'fields'
        ])
    },
    data () {
        const checkName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('Please input name'))
            }

            setTimeout(() => {
                if (/\s/.test(value)) {
                    callback(new Error('Name should not contain empty space'))
                } else {
                    callback()
                }
            }, 100)
        }

        return {
            rules: {
                name: [
                    { validator: checkName, trigger: 'blur' }
                ]
            },
            types: [
                { label: 'Calendar', value: 'calendar' },
                { label: 'Checkboxes', value: 'checkboxes' },
                { label: 'Color', value: 'color' },
                { label: 'Editor', value: 'editor' },
                { label: 'Integer', value: 'integer' },
                { label: 'List', value: 'list' },
                { label: 'Media', value: 'media' },
                { label: 'Radio', value: 'radio' },
                { label: 'Text', value: 'text' },
                { label: 'Text Area', value: 'textarea' }
            ],
            mappingTypes: [
                { label: 'E-Mail', value: 'email' },
                { label: 'Title', value: 'title' },
                { label: 'First Name', value: 'firstName' },
                { label: 'Last Name', value: 'lastName' },
                { label: 'Address Line 1', value: 'address1' },
                { label: 'Address Line 2', value: 'address2' },
                { label: 'State', value: 'state' },
                { label: 'City', value: 'city' },
                { label: 'ZIP', value: 'zip' },
                { label: 'Country', value: 'country' },
            ],
            field: {
                eventId: this.$route.params.eventId,
                title: '',
                name: '',
                description: '',
                type: null,
                labels: '', // labels for dropdown
                values: '', // values for dropdown
                defaultValue: '', // default value for text input
                requiredForExternal: false,
                fieldMapping: null,
                publicEditable: true,
                publicView: true
            },
            saving: false,
            loading: false,
            discountPeriodSet: 1
        }
    },
    methods: {
        submit: async function () {
            this.saving = true
            let res = null
            try {
                if (this.$route.params.fieldId) {
                    this.field.eventId = this.$route.params.eventId;
                    res = await http.put(`/api/checkpointfields/${this.$route.params.fieldId}`, this.field)
                    this.$notify('Information successfully updated!')
                } else {
                    res = await http.post(`/api/checkpointfields`, this.field)
                    this.$router.push({ name: 'checkpointfields' })
                    this.$notify('New field was successfully created!')
                }
            } catch (e) {
                console.log(e)
                this.$notify({
                    type: "danger",
                    message: e.response.data.message
                })
            }
            this.saving = false
        },
        getData: async function () {
            this.loading = true
            try {
                if (this.$route.params.fieldId) {
                    const res = await http.get(`/api/checkpointfields/${this.$route.params.fieldId}?eventId=${this.$route.params.eventId}`)
                    Object.keys(this.field).forEach(k =>{
                        this.field[k] = res.data.field[k]
                    })
                }
            } catch (e) {
                console.log(e)
                console.log('error getting field')
            }

            this.loading = false
        }
    }
}
</script>
